import { Button } from "@/components/ui/button";
import liverClosing from "@/assets/closing-scenes/liver-biome-plus-closing.webp.asset.json";
import ovaClosing from "@/assets/closing-scenes/ova-balance-closing.webp.asset.json";
import { useId, type ReactNode } from "react";
import type { IngredientStoryProduct } from "./ingredientStoryContent";
import "./FormulaClosingStory.css";

const CLOSING = {
  liver: {
    name: "Liver Biome Plus", handle: "liver-biome-plus",
    heading: ["Make daily care", "a habit."],
    deck: "Actives and probiotics. One formula. Daily nutritional support for liver health and gut balance.",
    image: liverClosing.url,
    alt: "Liver Biome Plus canister in a dark olive studio scene",
    action: "Choose my supply",
  },
  ova: {
    name: "Ova Balance", handle: "ova-balance",
    heading: ["Start your", "daily balance ritual."],
    deck: "An inositol-based sachet for cycle and metabolic support. One simple daily habit.",
    image: ovaClosing.url,
    alt: "Ova Balance canister and sachet in a deep plum studio scene",
    action: "View options",
  },
} as const;

/** Displays the existing live recap, then returns to the ONE real buy box. */
export default function FormulaClosingStory({ product, offerDetails, onChooseSupply }: {
  product: IngredientStoryProduct;
  offerDetails?: ReactNode;
  onChooseSupply: () => void;
}) {
  const id = useId();
  const copy = CLOSING[product];
  return <section className="formula-closing" data-product-tone={product} aria-labelledby={`${id}-closing-heading`}>
    <div className="formula-closing__copy">
      <p className="formula-closing__eyebrow">WITH {copy.name.toUpperCase()}</p>
      <h2 id={`${id}-closing-heading`}>{copy.heading[0]}<br />{copy.heading[1]}</h2>
      <p className="formula-closing__deck">{copy.deck}</p>
      {offerDetails && <div className="formula-closing__offer">{offerDetails}</div>}
    </div>
    <figure className="formula-closing__art">
      <img src={copy.image} alt={copy.alt} width={1122} height={1402} loading="lazy" decoding="async" />
    </figure>
    <div className="formula-closing__action">
      <Button variant="ghost" type="button" onClick={onChooseSupply}>{copy.action}<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 12h15M13 5l7 7-7 7" /></svg></Button>
      <p>Food supplement. Not a medicine.</p>
    </div>
  </section>;
}
